import { render, staticRenderFns } from "./CompraDeudaImport.vue?vue&type=template&id=4a49dec3&scoped=true"
import script from "./CompraDeudaImport.vue?vue&type=script&lang=js"
export * from "./CompraDeudaImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a49dec3",
  null
  
)

export default component.exports